/* Margad — front-end behaviours ported from the WordPress build.
   Replaces jQuery + Elementor + Qi + ElementsKit runtime with ~6 KB of vanilla JS.
   Widget markup is unchanged, so the original CSS keeps working. */
(function () {
  'use strict';
  var $ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn, false); };
  var parse = function (raw) { try { return JSON.parse(raw); } catch (e) { return null; } };

  /* ---------------------------------------------------------- background video */
  function backgroundVideo() {
    $('[data-settings]').forEach(function (el) {
      var s = parse(el.getAttribute('data-settings'));
      if (!s || s.background_background !== 'video' || !s.background_video_link) return;
      var video = el.querySelector('video.elementor-background-video-hosted');
      if (!video) return;
      var src = video.dataset.src || el.dataset.videoSrc || s.background_video_link;
      video.src = src;
      video.muted = true; video.loop = true; video.playsInline = true;
      var start = parseFloat(s.background_video_start || 0);
      on(video, 'loadedmetadata', function () { if (start) { try { video.currentTime = start; } catch (e) {} } });
      if (start) on(video, 'timeupdate', function () { if (video.currentTime < start - 0.5) video.currentTime = start; });
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* -------------------------------------------------------------- typeout text */
  function typeout() {
    $('.qodef-qi-typeout-text').forEach(function (el) {
      var words = parse(el.getAttribute('data-strings')) || [];
      var target = el.querySelector('.qodef-typeout');
      if (!target || !words.length) return;
      var holder = el.querySelector('.qodef-typeout-holder');
      var cursor = el.getAttribute('data-cursor');
      if (cursor && holder && !holder.querySelector('.qodef-typeout-cursor')) {
        var c = document.createElement('span');
        c.className = 'qodef-typeout-cursor'; c.textContent = cursor;
        holder.appendChild(c);
      }
      var w = 0, i = 0, deleting = false;
      (function tick() {
        var word = words[w];
        target.textContent = word.substring(0, i);
        if (!deleting && i < word.length) { i++; setTimeout(tick, 90); }
        else if (!deleting) { deleting = true; setTimeout(tick, 1800); }
        else if (i > 0) { i--; setTimeout(tick, 45); }
        else { deleting = false; w = (w + 1) % words.length; setTimeout(tick, 350); }
      })();
    });
  }

  /* --------------------------------------------------------------------- tabs */
  /* The original build used jQuery UI Tabs; the theme CSS is written against its
     class names and the aria-hidden attribute, so reproduce that contract. */
  function tabs() {
    $('.qodef-tabbed-info').forEach(function (el) {
      var nav = el.querySelector('.qodef-m-navigation');
      var links = $('.qodef-m-navigation a', el);
      var panes = $('.qodef-m-content', el);
      if (!nav || !links.length || !panes.length) return;

      el.classList.add('ui-tabs', 'ui-corner-all', 'ui-widget', 'ui-widget-content');
      nav.classList.add('ui-tabs-nav', 'ui-corner-all', 'ui-helper-reset',
                        'ui-helper-clearfix', 'ui-widget-header');
      links.forEach(function (a) {
        a.classList.add('ui-tabs-anchor');
        a.parentNode.classList.add('ui-tabs-tab', 'ui-corner-top', 'ui-state-default', 'ui-tab');
      });
      panes.forEach(function (p) {
        p.classList.add('ui-tabs-panel', 'ui-corner-bottom', 'ui-widget-content');
      });

      function show(idx) {
        links.forEach(function (a, i) {
          a.parentNode.classList.toggle('ui-tabs-active', i === idx);
          a.parentNode.classList.toggle('ui-state-active', i === idx);
          a.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
        panes.forEach(function (p, i) {
          p.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
          p.style.display = '';
        });
      }

      links.forEach(function (a, i) {
        a.setAttribute('href', '#');
        a.setAttribute('role', 'tab');
        on(a, 'click', function (e) { e.preventDefault(); show(i); });
        on(a, 'mouseenter', function () { a.parentNode.classList.add('ui-state-hover'); });
        on(a, 'mouseleave', function () { a.parentNode.classList.remove('ui-state-hover'); });
      });
      show(0);

      // panes are absolutely positioned, so the widget needs an explicit height
      function size() {
        var h = 0;
        panes.forEach(function (p) { h = Math.max(h, p.scrollHeight); });
        var navH = nav.getBoundingClientRect().height;
        if (h) el.style.minHeight = (h + navH) + 'px';
      }
      size();
      on(window, 'resize', size);
      if (window.ResizeObserver) new ResizeObserver(size).observe(el);
      $('img', el).forEach(function (im) { on(im, 'load', size); });

      el.style.visibility = 'visible';   // CSS hides it until the widget is wired up
    });
  }

  /* ---------------------------------------------------------------- accordion */
  function accordion() {
    $('.qodef-accordion').forEach(function (el) {
      var single = el.classList.contains('qodef-behavior--accordion');
      var titles = $('.qodef-accordion-title', el);
      el.style.visibility = 'visible';   // CSS keeps it hidden until wired up
      titles.forEach(function (t, i) {
        var pane = t.nextElementSibling;
        if (!pane || !pane.classList.contains('qodef-accordion-content')) return;
        var open = i === 0;
        function set(v) {
          open = v;
          t.classList.toggle('qodef--active', v);
          pane.style.display = v ? '' : 'none';
        }
        set(open);
        t.setAttribute('role', 'button');
        t.setAttribute('tabindex', '0');
        on(t, 'click', function () {
          if (single && !open) {
            titles.forEach(function (o) {
              if (o === t) return;
              o.classList.remove('qodef--active');
              if (o.nextElementSibling) o.nextElementSibling.style.display = 'none';
            });
          }
          set(!open);
        });
        on(t, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
      });
    });
  }

  /* ------------------------------------------------------------------ counters */
  function counters() {
    var items = $('.qodef-counter');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var end = parseFloat(el.getAttribute('data-end-digit') || '0');
        var label = el.getAttribute('data-digit-label') || '';
        var out = el.querySelector('.qodef-m-digit') || el.querySelector('.qodef-e-digit');
        if (!out) return;
        var t0 = null, dur = 1600;
        requestAnimationFrame(function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          out.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + (p === 1 ? label : '');
          if (p < 1) requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.4 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* -------------------------------------------------------------------- swiper */
  function swipers() {
    // Swiper is 140 KB and only two templates carry a carousel, so it is fetched
    // on demand instead of on every page. Nothing to do when there is no slider.
    if (!$('.qodef-qi-swiper-container').length && !$('.elementskit-clients-slider').length) return;

    if (typeof Swiper === 'undefined') {
      if (window.__margadSwiperPending || !window.MARGAD_SWIPER_URL) return;
      window.__margadSwiperPending = true;
      var sc = document.createElement('script');
      sc.src = window.MARGAD_SWIPER_URL;
      sc.onload = function () { window.__margadSwiperPending = false; swipers(); };
      document.head.appendChild(sc);
      return;
    }

    // Qi image sliders — options live on the container
    $('.qodef-qi-swiper-container').forEach(function (el) {
      var o = parse(el.getAttribute('data-options')) || {};
      if (!el.classList.contains('swiper')) el.classList.add('swiper');
      new Swiper(el, {
        slidesPerView: parseInt(o.slidesPerView, 10) || 1,
        spaceBetween: parseInt(o.spaceBetween, 10) || 0,
        loop: !!o.loop,
        speed: parseInt(o.speed, 10) || 600,
        autoplay: o.autoplay ? { delay: 4000, disableOnInteraction: false } : false,
        centeredSlides: !!o.centeredSlides,
        breakpoints: {
          0:    { slidesPerView: 1 },
          768:  { slidesPerView: Math.min(2, parseInt(o.slidesPerView, 10) || 1) },
          1024: { slidesPerView: parseInt(o.slidesPerView, 10) || 1 }
        }
      });
    });

    // ElementsKit client-logo carousel — options on the wrapper
    $('.elementskit-clients-slider').forEach(function (wrap) {
      var el = wrap.querySelector('.swiper');
      if (!el) return;
      var o = parse(wrap.getAttribute('data-config')) || {};
      var bp = {};
      Object.keys(o.breakpoints || {}).forEach(function (k) {
        bp[k] = { slidesPerView: o.breakpoints[k].slidesPerView, spaceBetween: o.breakpoints[k].spaceBetween };
      });
      new Swiper(el, {
        slidesPerView: o.slidesPerView || 4,
        spaceBetween: 15,
        loop: !!o.loop,
        speed: o.speed || 1000,
        autoplay: o.autoplay ? { delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: !!o.pauseOnHover } : false,
        breakpoints: bp
      });
    });
  }

  /* ------------------------------------------------------- header + navigation */
  function header() {
    var hdr = document.getElementById('qodef-page-header');
    if (hdr) {
      var sticky = function () {
        document.body.classList.toggle('qodef-header--sticky', window.pageYOffset > 120);
      };
      sticky(); on(window, 'scroll', sticky);
    }

    // mobile menu
    var nav = document.querySelector('.qodef-mobile-header-navigation');
    if (opener && nav) {
      on(opener, 'click', function (e) {
        e.preventDefault();
        var open = nav.classList.toggle('qodef--opened');
        nav.style.display = open ? 'block' : '';
        document.body.classList.toggle('qodef-mobile-menu--opened', open);
      });
    }
    // sub-menu toggles inside the mobile nav
    $('.qodef-mobile-header-navigation .menu-item-has-children > a').forEach(function (a) {
      on(a, 'click', function (e) {
        var li = a.parentNode, sub = li.querySelector('.sub-menu');
        if (!sub) return;
        e.preventDefault();
        var open = li.classList.toggle('qodef--opened');
        sub.style.display = open ? 'block' : '';
      });
    });

    // desktop drop-down ("Services"). The theme CSS keeps .qodef-drop-down-second
    // at height:0/opacity:0 and relied on jQuery to open it — there is no :hover
    // rule to fall back on, so drive it here.
    $('#qodef-page-header .menu-item-has-children').forEach(function (li) {
      var dd = li.querySelector('.qodef-drop-down-second');
      if (!dd) return;
      var inner = dd.querySelector('.qodef-drop-down-second-inner');
      var timer;
      function show() {
        clearTimeout(timer);
        li.classList.add('qodef--opened');
        dd.style.height = (inner ? inner.offsetHeight : dd.scrollHeight) + 'px';
        dd.style.opacity = '1';
        dd.style.visibility = 'visible';
        dd.style.overflow = 'visible';
      }
      function hide() {
        timer = setTimeout(function () {
          li.classList.remove('qodef--opened');
          dd.style.height = '0px';
          dd.style.opacity = '0';
          dd.style.visibility = 'hidden';
          dd.style.overflow = 'hidden';
        }, 120);
      }
      on(li, 'mouseenter', show);
      on(li, 'mouseleave', hide);
      on(li, 'focusin', show);
      on(li, 'focusout', hide);
      // touch devices have no hover: first tap opens, second follows the link
      var trigger = li.querySelector(':scope > a');
      if (trigger) {
        on(trigger, 'click', function (e) {
          if (window.matchMedia('(hover: hover)').matches) return;
          if (!li.classList.contains('qodef--opened')) { e.preventDefault(); show(); }
        });
      }
    });

    // back to top
    var top = document.getElementById('qodef-back-to-top');
    if (top) {
      on(top, 'click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
      var vis = function () { top.classList.toggle('qodef--on', window.pageYOffset > 600); };
      vis(); on(window, 'scroll', vis);
    }
  }

  /* ------------------------------------------------------------ reveal on scroll */
  /* Elementor ships entrance-animated elements with .elementor-invisible
     (visibility:hidden) and swaps in `animated <name>` when they scroll into
     view. Without that, those blocks never appear at all. */
  function reveal() {
    var els = $('.elementor-invisible').concat($('.qodef-appear, [data-appear]'));
    if (!els.length) return;

    function show(el) {
      var name = '';
      var s = parse(el.getAttribute('data-settings'));
      if (s) name = s.animation || s._animation || '';
      el.classList.remove('elementor-invisible');
      el.classList.add('qodef-appear--active');
      if (name && name !== 'none') el.classList.add('animated', name);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(show);          // no observer support: just make everything visible
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });

    // safety net: anything still hidden after 4s (never scrolled to, observer
    // never fired) gets shown so content can never be lost
    setTimeout(function () { $('.elementor-invisible').forEach(show); }, 4000);
  }

  /* --------------------------------------------------- qodef appear animations */
  /* Leroux ships these blocks at opacity:0 and its JS adds .qodef--appeared when
     they scroll into view. Without it the icon columns never become visible. */
  var APPEAR_SEL = [
    '.qodef--has-appear', '.qodef--has-svg-appear', '.qodef-parallax-item',
    '.qodef-m-image', '.qodef-m-svg', '.qodef-m-thumb-image', '.qodef-e-item'
  ].join(',');

  function appeared() {
    var els = $(APPEAR_SEL);
    if (!els.length) return;
    var mark = function (el) { el.classList.add('qodef--appeared'); };
    if (!('IntersectionObserver' in window)) { els.forEach(mark); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        mark(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
    // never let a block stay invisible because the observer didn't fire
    setTimeout(function () { $(APPEAR_SEL).forEach(mark); }, 4000);
  }

  /* ------------------------------------------------------- team member popups */
  /* ElementsKit uses Magnific Popup; reproduce just enough of its DOM for the
     ported CSS to style the dialog. */
  function teamPopup() {
    var triggers = $('.ekit-team-popup, [data-mfp-src]');
    if (!triggers.length) return;
    var bg, wrap, current;

    function close() {
      if (!current) return;
      current.classList.add('mfp-hide');
      if (current.__home) current.__home.appendChild(current);
      if (bg) bg.remove();
      if (wrap) wrap.remove();
      document.body.classList.remove('mfp-zoom-out-cur');
      document.documentElement.style.overflow = '';
      current = null;
    }

    function open(target) {
      close();
      current = target;
      if (!target.__home) target.__home = target.parentNode;

      bg = document.createElement('div');
      bg.className = 'mfp-bg mfp-zoom-in mfp-ready';
      wrap = document.createElement('div');
      wrap.className = 'mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-zoom-in mfp-ready';
      wrap.setAttribute('tabindex', '-1');
      var container = document.createElement('div');
      container.className = 'mfp-container mfp-inline-holder';
      var content = document.createElement('div');
      content.className = 'mfp-content';
      container.appendChild(content);
      wrap.appendChild(container);
      document.body.appendChild(bg);
      document.body.appendChild(wrap);

      target.classList.remove('mfp-hide');
      content.appendChild(target);
      document.documentElement.style.overflow = 'hidden';

      on(wrap, 'click', function (e) {
        if (e.target === wrap || e.target === container) close();
      });
      var x = target.querySelector('.ekit-team-modal-close, .mfp-close');
      if (x) on(x, 'click', function (e) { e.preventDefault(); close(); });
    }

    triggers.forEach(function (t) {
      on(t, 'click', function (e) {
        var sel = t.getAttribute('data-mfp-src') || t.getAttribute('href');
        if (!sel || sel.charAt(0) !== '#') return;
        var target = document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        open(target);
      });
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    try { backgroundVideo(); } catch (e) {}
    try { typeout(); } catch (e) {}
    try { tabs(); } catch (e) {}
    try { accordion(); } catch (e) {}
    try { counters(); } catch (e) {}
    try { swipers(); } catch (e) {}
    try { header(); } catch (e) {}
    try { reveal(); } catch (e) {}
    try { appeared(); } catch (e) {}
    try { teamPopup(); } catch (e) {}
  }

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', init);
  else init();
})();
